module.exports = __webpack_public_path__ + "static/media/covid.86282711.86282711.webp";